<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.title"
            placeholder="请输入轮播标题"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加轮播</el-button
          >
        </div>

        <el-table
          :data="tableData"
          height="900"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handlePcRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="轮播标题" prop="title" min-width="200" />
          <el-table-column label="轮播图片" width="180" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.image"
                style="width: 120px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column label="跳转链接" prop="url" min-width="200" />
          
          <!-- 状态列 上架/下架 -->
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="启用"
                inactive-text="禁用"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />

          <!-- 操作列 固定右侧 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handleDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="轮播详情"
          :visible.sync="pcShowCard"
          width="500px"
          center
          close-on-click-modal
          append-to-body
        >
          <div class="goods-card" v-if="pcCurrentRow">
            <div class="goods-img">
              <img :src="pcCurrentRow.image" alt="轮播图片" />
            </div>
            <div class="goods-info">
              <p>
                <label>ID：</label><span>{{ pcCurrentRow.id }}</span>
              </p>
              <p>
                <label>标题：</label><span>{{ pcCurrentRow.title }}</span>
              </p>
              <p>
                <label>跳转链接：</label><span>{{ pcCurrentRow.url || '无' }}</span>
              </p>
              <p>
                <label>状态：</label>
                <span>{{ pcCurrentRow.status == 1 ? "启用" : "禁用" }}</span>
              </p>
              <p>
                <label>创建时间：</label><span>{{ pcCurrentRow.created_at }}</span>
              </p>
              <p>
                <label>更新时间：</label><span>{{ pcCurrentRow.updated_at }}</span>
              </p>
            </div>
          </div>
        </el-dialog>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加轮播' : '编辑轮播'"
          :visible.sync="pcDialogVisible"
          width="600px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <el-form-item label="选择轮播图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="pcOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="pcForm.image"
                  style="border: 1px solid #eee; padding: 4px; border-radius: 4px"
                >
                  <img
                    :src="pcForm.image"
                    style="width: 120px; height: 60px; object-fit: cover; display: block"
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="轮播标题" prop="title">
              <el-input
                v-model="pcForm.title"
                placeholder="请输入轮播标题"
                style="width: 300px"
              />
            </el-form-item>
            <el-form-item label="跳转链接" prop="url">
              <el-input
                v-model="pcForm.url"
                placeholder="请输入跳转链接（可选）"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 10px"
          >
            <div
              style="display: flex; gap: 10px; margin-bottom: 15px; align-items: center"
            >
              <el-select
                v-model.number="pcImageSearch.type"
                placeholder="图片类型"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in imageTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="display: flex; flex-wrap: wrap; gap: 12px; max-height: 420px; overflow-y: auto; padding: 5px"
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="pcSelectImage(img)"
                style="cursor: pointer; padding: 4px; border-radius: 6px; text-align: center"
                :style="{
                  border: pcSelectedImageId === img.id ? '2px solid #1989fa' : '2px solid transparent',
                  background: pcSelectedImageId === img.id ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="width: 140px; height: 70px; object-fit: cover; border-radius: 4px; display: block"
                />
              </div>
            </div>

            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="pcImageSearch.page"
              :page-size="pcImageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectImage">确认选择</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.title"
            placeholder="轮播标题"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleMobileRowClick(item)"
          >
            <div class="card-header">
              <img :src="item.image" class="avatar" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="meta">ID:{{ item.id }}</div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "启用" : "禁用" }}
              </div>
            </div>
            <div class="card-body">
              <div>链接：{{ item.url || '无' }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDel(item)"
                >删除</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="启用"
                inactive-text="禁用"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(item)"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
          />
        </div>

        <!-- 移动端详情 -->
        <el-dialog
          title="轮播详情"
          :visible.sync="mobileShowCard"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileCurrentRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileCurrentRow.image"
                style="width: 250px; height: 120px; object-fit: cover; border-radius: 8px"
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{ mobileCurrentRow.id }}</el-descriptions-item>
              <el-descriptions-item label="标题">{{ mobileCurrentRow.title }}</el-descriptions-item>
              <el-descriptions-item label="跳转链接">{{ mobileCurrentRow.url || '无' }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span :style="mobileCurrentRow.status == 1 ? 'color:#00C48C' : 'color:#F56C6C'">
                  {{ mobileCurrentRow.status == 1 ? "启用" : "禁用" }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ mobileCurrentRow.created_at }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{ mobileCurrentRow.updated_at }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileShowCard = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加轮播' : '编辑轮播'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="选择图片">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="mobileOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileForm.image"
                  style="border: 1px solid #eee; padding: 2px; border-radius: 4px"
                >
                  <img
                    :src="mobileForm.image"
                    style="width: 120px; height: 60px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="轮播标题" prop="title">
              <el-input
                v-model="mobileForm.title"
                placeholder="标题"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="跳转链接" prop="url">
              <el-input
                v-model="mobileForm.url"
                placeholder="链接（可选）"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false">取消</el-button>
            <el-button type="primary" size="medium" @click="mobileSubmitForm">保存</el-button>
          </div>
        </el-dialog>

        <!-- 移动端图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="图片类型"
                size="mini"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in imageTypeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </div>
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-button size="mini" type="primary" @click="getImageList">筛选</el-button>
              <el-button size="mini" @click="resetImageSearch">重置</el-button>
            </div>

            <div
              style="display: flex; flex-wrap: wrap; gap: 8px; max-height: 45vh; overflow-y: auto; padding: 5px"
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="padding: 3px; border-radius: 6px; cursor: pointer; text-align: center"
                :style="{
                  border: mobileSelectedImageId === img.id ? '2px solid #1989fa' : '2px solid transparent',
                  background: mobileSelectedImageId === img.id ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="width: 140px; height: 70px; object-fit: cover; border-radius: 4px; display: block"
                />
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="imageTotal"
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false">取消</el-button>
            <el-button size="mini" type="primary" @click="mobileConfirmSelectImage">确认</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "BannerManage",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        title: "",
      },
      // 表单校验
      addRules: {
        title: [{ required: true, message: "请输入轮播标题", trigger: "blur" }],
        image: [{ required: true, message: "请选择轮播图片", trigger: "change" }],
      },

      // 图片选择公共
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      imageTypeList: [],

      // PC
      pcShowCard: false,
      pcCurrentRow: null,
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        banner_id: "",
        title: "",
        image: "",
        url: "",
      },
      pcImageDialogVisible: false,
      pcImageSearch: {
        page: 1,
        page_size: 12,
        type: "",
      },
      pcSelectedImageId: "",

      // 移动端
      mobileShowCard: false,
      mobileCurrentRow: null,
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        banner_id: "",
        title: "",
        image: "",
        url: "",
      },
      mobileImageDialogVisible: false,
      mobileImageSearch: {
        page: 1,
        page_size: 12,
        type: "",
      },
      mobileSelectedImageId: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 轮播图列表
    getList() {
      this.loading = true;
      api.banners
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 状态切换
    handleStatus(row) {
      const old = row.status;
      this.loading = true;
      api.banners
        .status({
          banner_id: row.id,
          status: row.status,
        })
        .catch(() => {
          row.status = old;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 删除
    handleDel(row) {
      this.$confirm("确定要删除该轮播图吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.banners.del({ banner_id: row.id }).then((res) => {
          if (res.data.code == 1000) {
            this.getList();
          }
        });
      });
    },

    // 获取图片列表（选择图片）
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.pcImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.imageList = res.data.data.data || [];
            this.imageTotal = res.data.data.total || 0;
            this.imageTypeList = res.data.data.image_type || [];
          }
        })
        .finally(() => {
          this.imageLoading = false;
        });
    },
    resetImageSearch() {
      this.pcImageSearch = {
        page: 1,
        page_size: 12,
        type: "",
      };
      this.mobileImageSearch = {
        page: 1,
        page_size: 12,
        type: "",
      };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.pcImageSearch.page_size = val;
      this.mobileImageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.pcImageSearch.page = val;
      this.mobileImageSearch.page = val;
      this.getImageList();
    },

    // ==================== PC ====================
    handlePcRowClick(row) {
      this.pcCurrentRow = row;
      this.pcShowCard = true;
    },
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        banner_id: row.id,
        title: row.title,
        image: row.image,
        url: row.url,
      };
      this.pcDialogVisible = true;
    },
    pcResetForm() {
      this.pcForm = {
        banner_id: "",
        title: "",
        image: "",
        url: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn = this.pcDialogType == "add" ? api.banners.add : api.banners.edit;
        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    pcOpenImageDialog() {
      this.pcImageDialogVisible = true;
      this.pcSelectedImageId = "";
      this.getImageList();
    },
    pcSelectImage(img) {
      this.pcSelectedImageId = img.id;
    },
    pcConfirmSelectImage() {
      if (!this.pcSelectedImageId) {
        this.$message.warning("请先选择图片");
        return;
      }
      const img = this.imageList.find(item => item.id === this.pcSelectedImageId);
      this.pcForm.image = img.url;
      this.pcImageDialogVisible = false;
    },

    // ==================== 移动端 ====================
    handleMobileRowClick(row) {
      this.mobileCurrentRow = row;
      this.mobileShowCard = true;
    },
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        banner_id: row.id,
        title: row.title,
        image: row.image,
        url: row.url,
      };
      this.mobileDialogVisible = true;
    },
    mobileResetForm() {
      this.mobileForm = {
        banner_id: "",
        title: "",
        image: "",
        url: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn = this.mobileDialogType == "add" ? api.banners.add : api.banners.edit;
        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageId = "";
      this.getImageList();
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageId = img.id;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageId) {
        this.$message.warning("请先选择图片");
        return;
      }
      const img = this.imageList.find(item => item.id === this.mobileSelectedImageId);
      this.mobileForm.image = img.url;
      this.mobileImageDialogVisible = false;
    },

    // ==================== 公共 ====================
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        title: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC 样式（和原页面完全一致） */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.goods-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px;
}
.goods-img img {
  width: 200px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}
.goods-info {
  flex: 1;
  font-size: 14px;
}
.goods-info p {
  margin: 10px 0;
  line-height: 1.6;
}
.goods-info label {
  font-weight: bold;
  width: 90px;
  display: inline-block;
}

/* 移动端样式（和原页面完全一致） */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 100px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/content/banners.vue